import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRef } from 'react';
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './Component_ResizableReviewPanel.scss';
const MIN_WIDTH_PX = 320; // keep the panel wide enough to read
const MAX_WIDTH_RATIO = 0.85; // keep ~15% of the editor/graph visible
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
/**
 * Right-docked, resizable HTML "Review" overlay shared by the pathway and disease-profile reviews.
 * Owns the overlay chrome + the left-edge drag bar + width persistence; callers derive src / label /
 * onClose from their own module. The iframe is fully sandboxed (sandbox="") with no referrer so the
 * download token never leaks via the Referer header.
 */
export class Component_ResizableReviewPanel extends ComponentSync {
    rootRef = createRef();
    deriveStateFromProps(nextProps, state) {
        state.widthPx ??= nextProps.storageKey.get();
        state.resizing ??= false;
        return state;
    }
    // Left-edge drag bar. Panel is right-docked, so cursor moving left widens it. Listeners live on
    // `window` so the drag keeps tracking off the bar; width is persisted only on release.
    onResizeStart = (e) => {
        e.preventDefault();
        const wrapper = this.rootRef.current;
        if (!wrapper)
            return;
        const region = wrapper.parentElement;
        const maxWidth = region ? region.clientWidth * MAX_WIDTH_RATIO : Number.MAX_SAFE_INTEGER;
        const startX = e.clientX;
        const startWidth = wrapper.clientWidth;
        this.setState({ resizing: true });
        const onMove = (ev) => {
            const next = clamp(startWidth + (startX - ev.clientX), MIN_WIDTH_PX, maxWidth);
            this.setState({ widthPx: next });
        };
        const onUp = () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            this.setState({ resizing: false });
            if (this.state.widthPx != null)
                this.props.storageKey.set(this.state.widthPx);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    };
    render() {
        return _jsxs(LL_V_L, { innerRef: this.rootRef, className: _className('review-overlay', this.state.resizing && 'is-resizing'), style: this.state.widthPx != null ? { width: `${this.state.widthPx}px` } : undefined, children: [_jsx("div", { className: 'review-overlay__resizer', onMouseDown: this.onResizeStart }), _jsxs(LL_H_C, { className: 'review-overlay__header', children: [_jsxs(LL_H_C, { className: 'review-overlay__title-group', children: [_jsx("span", { className: 'review-overlay__title', children: this.props.title }), this.props.label && _jsx("span", { className: 'review-overlay__name', children: this.props.label })] }), _jsx(ICONS.x.component, { className: 'review-overlay__close', onClick: this.props.onClose })] }), _jsx("iframe", { className: 'review-overlay__frame', src: this.props.src, sandbox: '', referrerPolicy: 'no-referrer', title: this.props.title })] });
    }
}
//# sourceMappingURL=Component_ResizableReviewPanel.js.map